import { NextPageContext } from 'next';
import { redirectTo404 } from 'lib/constants';
import { getCurrentUserFromContext } from 'server/api/services/auth';
import { serialize } from 'lib/helpers';
import { GondolaHead } from 'components/GondolaHead/GondolaHead';
import { ProfileUser } from 'lib/types/users';
import { imageUrl } from 'lib/utils/imageUtils';
import { UserService } from 'server/api/services/users/user';
import { Job } from 'lib/types/jobs';
import { JobService } from 'server/api/services/jobs';
import { AwaitUserAuth } from 'components/AwaitUserAuth';
import { ProspectsJobDetail } from 'features/JobDetail';
import { UserListsProvider } from 'lib/contexts/userListsContext';

export const getServerSideProps = async (context: NextPageContext) => {
  const { query } = context;
  const currentUser = serialize(await getCurrentUserFromContext(context));

  const usernameInUrl = query.profileuser as string;

  const profileUser = await UserService.getProfileByUsername(usernameInUrl, currentUser?.id);

  if (!profileUser) {
    return redirectTo404;
  }

  const js = await JobService.build({ currentUser });
  const job = await js.getProspectsJob(profileUser.id);

  if (!job) {
    return redirectTo404;
  }

  return {
    props: {
      profileUser: serialize(profileUser),
      job: serialize(job),
    },
  };
};

interface Props {
  profileUser: ProfileUser;
  job: Job;
}
const ProspectsPage = ({ profileUser, job }: Props) => {
  const jobTitle = `Join ${profileUser.name}'s prospects list`;

  return (
    <>
      <GondolaHead
        title={jobTitle}
        image={profileUser.avatarUrl}
        description={job.description || 'Join our prospects list'}
        url={`https://gondola.cc/${profileUser.username}/work-for-us`}
        cardUrl={imageUrl(profileUser.cardUrl)}
      />

      <AwaitUserAuth>
        <UserListsProvider>
          <ProspectsJobDetail profileUser={profileUser} job={job} />
        </UserListsProvider>
      </AwaitUserAuth>
    </>
  );
};

// eslint-disable-next-line import/no-default-export
export default ProspectsPage;
